import { Grid } from '@mui/material';
import { SongData } from 'services/store/distribution/types';
import { DurationSection, StatusSection, TrackSection } from './components';
import { StyledSongItemContainer } from './styled';

type PropsType = {
  song: SongData;
};

const SongRow = ({ song }: PropsType) => (
  <StyledSongItemContainer>
    <Grid item xs={8}>
      <TrackSection song={song} />
    </Grid>
    <Grid item xs={2}>
      <DurationSection duration={song.duration} />
    </Grid>
    <Grid item xs={2}>
      <StatusSection song={song} />
    </Grid>
  </StyledSongItemContainer>
);

export default SongRow;
